import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children, userType }) {
  const { currentUser } = useAuth();

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If userType is specified, check if the user has the required type
  if (userType && currentUser.userType !== userType) {
    // Redirect to the appropriate dashboard based on user type
    if (currentUser.userType === 'rider') {
      return <Navigate to="/rider/dashboard" />;
    } else if (currentUser.userType === 'driver') {
      return <Navigate to="/driver/dashboard" />;
    } else if (currentUser.userType === 'admin') {
      return <Navigate to="/admin/dashboard" />;
    }
  }

  // If all checks pass, render the protected component
  return children;
}

export default PrivateRoute;
